import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export default Form;
